/** Floating desktop panel; the left side of the CRM remains interactive. Height comes from `--crm-viewport-h` (AppShell). */
export const CRM_PANEL_SURFACE =
  'lg:absolute lg:right-0 lg:top-0 lg:z-20 lg:h-[var(--crm-viewport-h)] lg:w-[calc(100%-min(35.125rem,45%))] lg:overflow-hidden lg:rounded-xl lg:border lg:border-border lg:shadow-[0_12px_40px_-12px_rgb(0_0_0/0.22),0_2px_8px_rgb(0_0_0/0.06)]';

/** Карточка в двухколоночном inbox (без absolute — иначе ломается вёрстка). */
export const CRM_INBOX_CARD =
  'flex min-h-0 flex-col overflow-hidden rounded-xl border border-border bg-background shadow-sm';
